module.exports = __webpack_public_path__ + "static/img/9.fe73d249.jpg";